import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CardSpacer from "@saleor/components/CardSpacer";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import Hr from "@saleor/components/Hr";
import Skeleton from "@saleor/components/Skeleton";
import { commonMessages } from "@saleor/intl";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { SiteLanguageDetailPageFormData } from "../SiteLanguageDetailPage";

export interface SiteLanguageSummaryProps {
  data: SiteLanguageDetailPageFormData;
}

const SiteLanguageSummary: React.FC<SiteLanguageSummaryProps> = ({ data }) => {
  const intl = useIntl();

  return (
    <Card>
      <CardTitle title={intl.formatMessage(commonMessages.summary)} />
      <CardContent>
        <Typography variant="caption">
          <FormattedMessage
            defaultMessage="Name"
            description="pageheader name"
          />
        </Typography>
        <Typography>
          {maybe<React.ReactNode>(() => data.language, <Skeleton />)}
        </Typography>
        <FormSpacer />

        <Typography variant="caption">
          <FormattedMessage
            defaultMessage="Domain"
            description="value display in pc"
          />
        </Typography>
        <Typography>
          {maybe<React.ReactNode>(() => data.domain, <Skeleton />)}
        </Typography>
        <FormSpacer />

        <Typography variant="caption">
          <FormattedMessage
            defaultMessage="Language Code"
            description="value display in mobile"
          />
        </Typography>
        <Typography>
          {maybe<React.ReactNode>(() => data.name, <Skeleton />)}
        </Typography>
        <FormSpacer />

        <CardSpacer />
        <Hr />
        <CardSpacer />
      </CardContent>
    </Card>
  );
};
SiteLanguageSummary.displayName = "SiteLanguageSummary";
export default SiteLanguageSummary;
